/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import DialogModal from "../DialogModal/DialogModal";
import { DialogProps } from "@mui/material/Dialog";

type PensionsDivorceModalProps = {
  open: boolean;
  onClose:  () => void;
  personType: string;
} & DialogProps;

const PensionsDivorceModal = ({ open, onClose, personType, ...rest }: PensionsDivorceModalProps) => {
  return (
    <DialogModal open={open} onClose={onClose} {...rest} title={"Rentenversicherungen"}>
      <p>
        Im Normalfall gibt es je eine gesetzliche Rentenversicherung pro Ehepartner.
        {personType === "client" ? " Sollten Sie" : " Sollte Ihr Ehepartner"} jedoch zum Beispiel zusätzlich eine private
        Rentenversicherung (betriebliche Altersvorsorge oder Riesterrente) haben, geben Sie bei der Anzahl
        Rentenversicherungen eine 2 an.
      </p>
    </DialogModal>
  );
};

export default PensionsDivorceModal;
